import { render, staticRenderFns } from "./DataTableAuctions.vue?vue&type=template&id=c29a9540&scoped=true&"
import script from "./DataTableAuctions.vue?vue&type=script&lang=js&"
export * from "./DataTableAuctions.vue?vue&type=script&lang=js&"
import style0 from "./DataTableAuctions.vue?vue&type=style&index=0&id=c29a9540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29a9540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
